import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'login-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.css']
})
export class FailedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
